(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDetailController', PhoneCallCheckDetailController);

    /* Added UIFormAccess
    PhoneCallCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose'];

    function PhoneCallCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose) {
    */
    PhoneCallCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose', 'UIFormAccess'];

    function PhoneCallCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose, UIFormAccess) {
        var vm = this;

        vm.phoneCallCheck = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallCheckUpdate', function(event, result) {
            vm.phoneCallCheck = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
